import { POS_ORDER_STATUS_OPTIONS } from '@src/types/onlineOrder';

export const STATUS_SELECT_OPTIONS = POS_ORDER_STATUS_OPTIONS.map((opt) => ({
  label: opt.label,
  value: opt.value,
}));

export const DELIVERY_MINUTE_PRESETS = [
  { label: '15 min', value: 15 },
  { label: '20 min', value: 20 },
  { label: '30 min', value: 30 },
  { label: '45 min', value: 45 },
  { label: '60 min', value: 60 },
];

export const ORDER_FILTER_TABS = [
  { key: 'active', label: 'Active' },
  { key: 'all', label: 'All' },
  { key: 'delivered', label: 'Delivered' },
  { key: 'cancelled', label: 'Cancelled' },
] as const;

export type OrderFilterTab = (typeof ORDER_FILTER_TABS)[number]['key'];

export const STATUS_SELECT_MENU_PROPS = {
  menuPortalTarget: typeof document !== 'undefined' ? document.body : null,
  menuPosition: 'fixed' as const,
  menuPlacement: 'auto' as const,
  styles: {
    menuPortal: (base: Record<string, unknown>) => ({ ...base, zIndex: 9999 }),
  },
};

export const PAYMENT_SELECT_MENU_PROPS = {
  ...STATUS_SELECT_MENU_PROPS,
  styles: {
    ...STATUS_SELECT_MENU_PROPS.styles,
    control: (base: Record<string, unknown>) => ({
      ...base,
      minHeight: 34,
      borderRadius: 10,
      borderColor: 'rgba(31, 35, 64, 0.12)',
      boxShadow: 'none',
      background: '#fff',
    }),
    valueContainer: (base: Record<string, unknown>) => ({
      ...base,
      padding: '0 8px',
    }),
    singleValue: (base: Record<string, unknown>) => ({
      ...base,
      fontSize: '0.8125rem',
      fontWeight: 600,
      textTransform: 'capitalize' as const,
    }),
    indicator: (base: Record<string, unknown>) => ({
      ...base,
      padding: 4,
    }),
  },
};
